import React, { useEffect } from 'react';
import { cn } from '../../lib/utils';

const KEYFRAMES_ID = 'linear-progress-indeterminate-keyframes';
const KEYFRAMES_CSS = `
@keyframes linear-progress-slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(350%);
  }
}
`;

export interface LinearProgressProps {
  className?: string;
}

export const LinearProgress: React.FC<LinearProgressProps> = ({ className }) => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }
    if (document.getElementById(KEYFRAMES_ID)) {
      return;
    }
    const styleTag = document.createElement('style');
    styleTag.id = KEYFRAMES_ID;
    styleTag.textContent = KEYFRAMES_CSS;
    document.head.appendChild(styleTag);
  }, []);

  return (
    <div className={cn('relative h-1.5 w-full overflow-hidden rounded-full bg-primary/10', className)}>
      <span
        className="absolute top-0 h-full origin-left rounded-full"
        style={{
          left: '0%',
          width: '40%',
          background: 'linear-gradient(90deg, rgba(59,131,246,0) 0%, rgba(59,131,246,0.95) 45%, rgba(59,131,246,0) 100%)',
          animation:
            'linear-progress-slide 1.4s linear infinite',
          filter: 'blur(0.35px)',
        }}
      />
    </div>
  );
};
